<div class="modal-header">
    <div class="title">
        <h2 class="modal-title" *ngIf="!this.role">Informations de l’utilisateur</h2>
        <h2 class="modal-title" *ngIf="this.role === 'Provider'">Informations du fournisseur</h2>
        <h2 class="modal-title" *ngIf="this.role === 'Shop'">Informations de la boutique</h2>
        <h4 class="modal-title" style="text-transform: uppercase;">{{ this.userInfos.fullName}} - {{ this.userInfos.id}}</h4>
        <h6>
          <span *ngIf="this.userInfos.isActive !== true" style="color: #dd6666;">Désactivé</span>
          <div *ngIf="this.userInfos.isActive == true">
            <span style="color: #00cb4c;">
                Actif
            </span>
            - Connecté le {{this.userInfos.lastConnect | date:'fullDate'}} à {{this.userInfos.lastConnect | date:'shortTime'}}
          </div>
        </h6>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body d-flex flex-column ">
    <div class="row">
        <div class="col-sm-12 info-block">
            <div class="container">
                <div class="info">
                    <div class="d-flex flex-row">
                        <div class="d-flex flex-column flex-33">
                            <h5 class="title">{{this.userInfos.fullName}}</h5>
                            <!-- Adresse -->
                            <div class="info-detail-block d-flex flex-row">
                                <i class="fa fa-home" aria-hidden="true"></i>
                                <div>
                                    <p *ngIf="this.role === 'Provider'">{{this.userInfos.adressStreet}}</p>
                                    <p *ngIf="this.role === 'Shop'">{{this.userInfos.shopAddress}}</p>
                                    <p *ngIf="this.role === 'Provider'">{{this.userInfos.adressPostalCode}} {{this.userInfos.adressState}} {{this.userInfos.adressCity}}
                                        <span *ngIf="this.userInfos.adressCountry">, </span>{{this.userInfos.adressCountry}}
                                    </p>
                                    <p *ngIf="this.role === 'Shop'">{{this.userInfos.shopPostalCode}} {{this.userInfos.shopAddressSup}} {{this.userInfos.shopCity}}
                                        <span *ngIf="this.userInfos.shopCountry">, </span>{{this.userInfos.shopCountry}}
                                    </p>
                                </div>
                            </div>
                            <div class="info-detail-block d-flex flex-row">
                                <i *ngIf="this.userInfos.geolocation" class="fa fa-map-marker" aria-hidden="true"></i>
                                <div>
                                    <!-- <p>Coordonnés de géolocalisation</p> -->
                                    <p>{{this.userInfos.geolocation}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- Contact -->
                        <div class="d-flex flex-column flex-33">
                            <h5 class="title">Contact</h5>
                            <div class="info-detail-block d-flex flex-row">
                                <i *ngIf="this.userInfos.email" class="fa fa-envelope-o" aria-hidden="true"></i>
                                <div>
                                    <p>{{this.userInfos.email}}</p>
                                </div>
                            </div>
                            <div class="info-detail-block d-flex flex-row">
                                <i *ngIf="this.userInfos.phone || this.userInfos.telephoneNumber" class="fa fa-phone" aria-hidden="true"></i>
                                <div>
                                    <p *ngIf="this.role === 'Provider'">{{this.userInfos.phone}}</p>
                                    <p *ngIf="this.role === 'Shop'">{{this.userInfos.telephoneNumber}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- Société -->
                        <div class="d-flex flex-column flex-33">
                            <h5 class="title">Société</h5>
                            <div>
                                <p *ngIf="this.role === 'Provider'">{{this.userInfos.providerName}}</p>
                                <p *ngIf="this.role === 'Shop'">{{this.userInfos.shopName}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
